import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15c97df8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Sulu: require('/opt/ft.kg/node_modules/@razlet/sulu-sdk/src/components/index.vue').default})
